// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2l6iS","clinicsSelect":"styles_clinicsSelect__1WmyN"};